declare namespace $ {

	type $shm_hitalama_map_overlayed__entity_shm_hitalama_app_overlay_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['overlayed_map_entity'] >
		,
		ReturnType< $shm_hitalama_map_overlayed['entity'] >
	>
	type $mol_view__sub_shm_hitalama_app_overlay_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['overlayed_map_visible'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_app_overlay_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_app_overlay_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_overlay['fullscreen_close_uri'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_view__sub_shm_hitalama_app_overlay_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_app_overlay extends $mol_view {
		overlayed_map_entity( ): any
		Overlayed_map( ): $shm_hitalama_map_overlayed
		overlayed_map_visible( ): readonly(any)[]
		Overlayed_map_holder( ): $mol_view
		Quick_access( ): $shm_hitalama_profile_quick
		Notifications( ): $shm_hitalama_notifications
		Fullscreen_close_icon( ): $mol_icon_arrow_expand_all
		fullscreen_close_uri( ): string
		Fullscreen_close( ): $mol_link_iconed
		Fullscreen_panel( ): $mol_view
		fullscreen_panel( ): readonly(any)[]
		hide_popover( ): any
		show_popover( id: any): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=overlay.view.tree.d.ts.map